var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "confirmation-popup",
    {
      ref: "popup",
      attrs: {
        title: _vm.resource(
          "DmVisualizer_ScenarioSelectionConfirmationPopup_Title"
        ),
        texts: _vm.texts
      }
    },
    [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          on: {
            click: function($event) {
              return _vm.$emit("confirm")
            }
          }
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(
                _vm.resource(
                  "DmVisualizer_ScenarioSelectionConfirmationPopup_ConfirmationButtonText"
                )
              ) +
              "\n    "
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }